<script>
    import { getClosedNearDates, openingHoursString } from "./opening-hours.utils";
    const closedNearDates = getClosedNearDates();
</script>

{@html openingHoursString()}

{#if closedNearDates.length}
    <div class="font-semibold">Stängt dessa dagar: {closedNearDates.map((d) => d.format("D/M")).join(", ")}</div>
{/if}
